module.exports = __webpack_public_path__ + "static/img/banner@2x.a0a39db.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/QuestionHeader/images/banner@2x.png
// module id = c81r
// module chunks = 1